import { createBrowserRouter } from 'react-router-dom';

import LoginRoutes from './LoginRoutes';
import { MainRoutesObject } from './MainRoutes';

const router = createBrowserRouter([LoginRoutes, MainRoutesObject]);

export default router;
